export enum SearchSource {
  PopularSearches = 'Popular searches',
  SuggestedSearchTerm = 'Suggested search term',
  SuggestedCategory = 'Suggested category',
  SuggestedPDP = 'Suggested PDP',
  SearchTermManually = 'Search term manually',
}
